<app-private-header/>
<div class="container">
	<router-outlet/>
</div>
<app-footer/>
